<template>
    <div>
      <FormulaBanner :title="title" :formulaCode="formulaCode"/>
      <div class="index">
        <!-- 表单 -->
        <div>
          <div class="top_nav"><span></span>{{title}}
          </div>
          <div class="formBody">
            <!-- 表单 -->
            <MyPatient :memberId="memberId" :selectValue="selectValue" @change="userChange"/>
            <TemplateFiveList :type="'radio'" :list-data="listData" :selectValue="listSelect" @change="listChange"></TemplateFiveList>
            <TemplateFiveList :type="'radio'" :list-data="list5Data" :selectValue="list5Select" @change="list5Change"></TemplateFiveList>
            <TemplateFiveList :type="'radio'" :list-data="list1Data" :selectValue="list1Select" @change="list1Change"></TemplateFiveList>
            <div v-if="compute === true" style="margin: 16px;display: flex;justify-content: center;">
              <van-button class="formula-template-button" block type="info" @click="submit" style="width:90px">提交</van-button>
            </div>
          </div>
        </div>
        <!-- <CalculationResults :countText="countValue" :countTextList="countTextList" v-if="show"></CalculationResults> -->
        <multipleResult v-if="show" :countText="countText" :countTextList="countResultARR"></multipleResult>
        <!-- 后台设置的值 -->
        <FormulaExplain :explain-data="tableData.explain"></FormulaExplain>
        <!-- 参考文献 -->
        <FormulaReferences :references-data="tableData.references"></FormulaReferences>
      </div>
  
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
            title="应激指数"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
      </van-popup>
  
    </div>
  
  </template>
  
  <script>
  import MyPatient from '@/components/MyPatient.vue'
  import FormulaBanner from '@/components/FormulaBanner.vue'
  import {Toast} from "vant";
  import {getAdmins} from "@/utils/adminDate";
  import {setById} from "@/service/base";
  import {getFormula, getFormulaHuiXian, postFormula} from "@/service/BodyMassIndex_api";
  import FormulaExplain from "@/components/template1/FormulaExplain";
  import FormulaReferences from "@/components/template1/FormulaReferences";
  import TemplateFiveList from "@/components/Template5/TemplateFiveList";
  import multipleResult from "@/components/multipleResult";
  export default {
    name: "medicalSearch",
    data(){
      return{
        compute:true,
        countTextList:[],
        show:false,
        countValue:"",
        listSelect: [],
        listData: [
          {
            title: '过去三个月内有没有因为食欲不振、消化问题、咀嚼吞咽困难而减少食量?',
            columns: ['食量严重减少', '食量中度减少', '食量没有改变'],
            fenzhi: [0,1,2] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '过去三个月内体重下降的情况',
            columns: ['体重下降大于3公斤(6.6磅)','不知道','体重下降1-3 公斤(2.2-6.6磅)','体重没有下降'],
            fenzhi: [0,1,2,3]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '活动能力',
            columns: ['需长期卧床或坐轮椅','可以下床或离开轮椅、但不能外出','可以外出'],
            fenzhi: [0,1,2]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '过去三个月内有没有受到心理创伤或患上急性疾病?',
            columns: ['有','没有'],
            fenzhi: [0,2]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          },
          {
            title: '精神心理',
            columns: ['严重痴呆或抑郁','轻度痴呆','没有精神心理问题'],
            fenzhi: [0,1,2]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          }
        ],
        list1Data:[
          // {
          //   title: '呼吸频率≥30次/分',
          //   columns: ['是','否'],
          //   fenzhi: [1,0] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！ 
          // },
        ],
        list1Select: [],
        formulaCode: '',
        shengao: '',
        yingjizhishu: '',
        title: '',
        memberId: '1111',
        selectValue: '',
        username:"",
        value:"",
        showPopover: false,
        showPicker: false,
        columns: ['', '', '',''],
        nianling: '',
        xingbie: null,
        tableData: {},
        countText: '',
        patientId: null,
        result: null,
        yingjizhishuzhi: '',
        tizhong: '',
        xueqingnanongdu: '',
        fenzhiList: [],
        fenzhi1List:[],
        list5Data: [
          {
            title: '是否可取得实际质量指数（BMI）',
            columns: ['是','否'],
            fenzhi: [0,0]  //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          }
        ],
        list5Select: [],
        fenzhi5List:[],
      }
    },
    components: {
      FormulaBanner,
      MyPatient,
      FormulaExplain,
      FormulaReferences,
      TemplateFiveList,
      //   CalculationResults
      multipleResult
    },
    async created() {
      await this.test()
      await this.getTableData()
    },
  
    methods:{
      list5Change (result, fenzhi) {
        // this.fenzhiList = []
        this.show=false
        this.list5Select = result //结果数组
        this.fenzhi5List = fenzhi  //分值数组
        if (result.some(item => item.value[0] === "是")) {
          this.list1Data = [
            {
              title: '身体质量指数(BMI)',
              columns: ['BMI < 19 kg/m²','BMI = 19-20.9 kg/m²','BMI = 21-22.9 kg/m²','BMI > 23kg/m²'],
              fenzhi: [0,1,2,3] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
            }
          ]
        } else if (result.some(item => item.value[0] === "否")) {
          this.list1Data = [
            {
              title: '小腿围(cc)(cm)',
              columns: ['cc<31cm','cc≥31cm'],
              fenzhi: [0,3] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！ 
            }
          ]
        }
        this.list1Select = []
        this.fenzhi1List = []
        // console.log("分值",this.list1Select,this.fenzhi1List)
      },
      listChange (result, fenzhi) {
        // this.fenzhiList = []
        this.show=false
        this.listSelect = result //结果数组
        this.fenzhiList = fenzhi  //分值数组
        // console.log("分值",this.list1Select,this.fenzhi1List)
      },
      list1Change (result, fenzhi) {
        // this.fenzhiList = []
        this.show=false
        this.list1Select = result //结果数组
        this.fenzhi1List = fenzhi  //分值数组
        // console.log("分值",result,fenzhi)
      },
      coumputTetxt () {
        // 如果选了>50岁，就删掉另一边的选项
        let fenshu = 0
        for (let i = 0; i < this.fenzhiList.length; i++) {
          fenshu += this.fenzhiList[i]
        }
        this.result = fenshu 
        if (this.list1Select.some(item => item.title === "身体质量指数(BMI)" && item.value[0] === "BMI < 19 kg/m²")) {
          fenshu += 0
        }else if(this.list1Select.some(item => item.title === "身体质量指数(BMI)" && item.value[0] === "BMI = 19-20.9 kg/m²")) {
          fenshu += 1 
        }else if(this.list1Select.some(item => item.title === "身体质量指数(BMI)" && item.value[0] === "BMI = 21-22.9 kg/m²")) {
          fenshu += 2
        }else if(this.list1Select.some(item => item.title === "身体质量指数(BMI)" && item.value[0] === "BMI > 23kg/m²")) {
          fenshu += 3
        }
        if (this.list1Select.some(item => item.title === "小腿围(cc)(cm)" && item.value[0] === "cc<31cm")) {
          fenshu += 0 
        } else if(this.list1Select.some(item => item.title === "小腿围(cc)(cm)" && item.value[0] === "cc≥31cm")) {
          fenshu += 3
        }
        if(fenshu  <= 7 && fenshu  >= 0){  
          this.countResultARR = 
          [
            {name:'总分',result:fenshu,unit:'分'},
            {name:'营养状态',result:'营养不良'}
          ]
          this.countText = `${fenshu}分 营养状态：营养不良`
        }else if(fenshu  <= 11 && fenshu  >= 8){  
          this.countResultARR = 
          [
            {name:'总分',result:fenshu,unit:'分'},
            {name:'营养状态',result:'营养不良风险'}
          ]
          this.countText = `${fenshu}分 营养状态：营养不良风险`
        }else if(fenshu  <= 14 && fenshu  >= 12){  
          this.countResultARR = 
          [
            {name:'总分',result:fenshu,unit:'分'},
            {name:'营养状态',result:'营养正常'}
          ]
          this.countText = `${fenshu}分 营养状态：营养正常`
        }
        this.show = true
      },
      async test(){
        //像接口头部传用户信息
        let arrays = await getAdmins(this.$route.query.memberId,this.$route.query.channel)
        this.channel = arrays.os
        this.version = arrays.version
        this.ip = arrays.ip
        await setById(arrays)
      },
      async getTableData () {
        const data = {
          channel: this.$router.currentRoute.query.channel,
          code: 'GGEPCCMF',
        }
        const res = await getFormula(data.channel, data.code)
        if (res.code === 0) {
          this.tableData = res.data
          this.formulaCode = res.data.code
          this.title = res.data.chineseName
        }
        if (this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' && this.$router.currentRoute.query.logId) {
          // this.compute = false
          const data = {
            id: this.$router.currentRoute.query.logId
          }
          const res = await getFormulaHuiXian(data)
          if (res.code === 0) {
            // console.log("选项", res.data.content.data)
            if (res.data.content.da5ta.some(item => item.value[0] === "是")) {
              this.list1Data = [
                {
                  title: '身体质量指数(BMI)',
                  columns: ['BMI < 19 kg/m²','BMI = 19-20.9 kg/m²','BMI = 21-22.9 kg/m²','BMI > 23kg/m²'],
                  fenzhi: [0,1,2,3] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
                }
              ]
            } else if (res.data.content.da5ta.some(item => item.value[0] === "否")) {
              this.list1Data = [
                {
                  title: '小腿围(cc)(cm)',
                  columns: ['cc<31cm','cc≥31cm'],
                  fenzhi: [0,3] //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！ 
                }
              ]
            }
            this.listSelect = res.data.content.data
            this.list1Select = res.data.content.da1ta
            this.list5Select = res.data.content.da5ta     
            if (res.data.patientId) this.selectValue = {id: res.data.patientId, name: res.data.patientName}
            this.fenzhiList = [res.data.result.value]
            // this.result = res.data.result.value
            this.countValue=res.data.result.DisplayResults
            this.show=true
            this.countResultARR = res.data.result.value
            this.countText = res.data.result.DisplayResults.replace(/'/g, '`')
            this.show=true
          }
        }
      },
      async submit () {
        // console.log("选项", this.list5Select.length !== 1,this.listSelect.length !== 6,this.list1Select.length !== 2)
        // if (this.list5Select.length !== 1 || this.listSelect.length !== 6 || this.list1Select.length !== 2) {
        //   Toast.fail('请完善选择')
        //   return
        // }
        this.coumputTetxt()
        const data = {
          id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
          patientId: this.patientId,
        //   columnCode: this.tableData.columnCode,
          columnCode: 'ZZYY',
          formulaCode: this.tableData.code,
          channel: this.$router.currentRoute.query.channel,
          location: this.$router.currentRoute.query.location,
          content: {
            data: this.listSelect,
            da1ta: this.list1Select,
            da5ta: this.list5Select,
            // xueqingnanongdu: {value: this.xueqingnanongdu, unit: 'mmol/L'},
          },
          result: {
            // value: this.result,
            result: this.countText,
            DisplayResults:this.countText,
            value: this.countResultARR,
          }
        }
        const res = await postFormula(data)
        if (res.code === 0) {
          Toast.success('提交成功')
        } else {
          Toast.fail(res.message)
        }
      },
      calculateAge(birthDateString) {
        const today = new Date();
        const birthDate = new Date(birthDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        // 如果今天的日期还没到生日月份和日期，则年龄减一
        if (today.getMonth() < birthDate.getMonth() ||
            (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      },
      // 开参考文献链接
      openLink(u){
        if (!u) {
          return
        }
        //获取系统版本
        let userAI = navigator.userAgent;
        const isAndroid = userAI.indexOf('Android') > -1 || userAI.indexOf('Linux') > -1; //Android终端
        const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) {
          // alert('安卓操作系统')
          // 这个是安卓操作系统
          window.open(u)
        }
        if (isIOS) {
          // 这个是ios操作系统
          // alert('ios操作系统')
          window.location.href = u
        }
      },
      yingjiClick () {
        this.showPicker = true
      },
      onConfirm(value) {
        this.yingjizhishu = value
        this.showPicker = false
      },
      onCancel() {
        this.showPicker = false
      },
      async onSubmit(){
        this.coumputTetxt()
        const data = {
          id: this.$router.currentRoute.query.location === 'YXGS_RECORD_LIST' ? this.$router.currentRoute.query.logId : null,
          patientId: this.patientId,
          columnCode: this.tableData.columnCode,
          formulaCode: this.tableData.code,
          channel: this.$router.currentRoute.query.channel,
          location: this.$router.currentRoute.query.location,
          content: {
            shengao: {value: this.shengao, unit: 'cm'},
            tizhong: {value: this.tizhong, unit: 'kg'},
            nianling: {value: this.nianling, unit: '岁'},
            xingbie: {value: this.xingbie == 1 ? '男' : '女'},
            // xueqingnanongdu: {value: this.xueqingnanongdu, unit: 'mmol/L'},
          },
          result: {}
        }
        if (this.xingbie == 1) {
          data.result.nanxing = {value: this.result, unit: 'kcal'}
        } else {
          data.result.nvxing = {value: this.result, unit: 'kcal'}
        }
        const res = await postFormula(data)
        if (res.code === 0) {
          Toast.success('提交成功')
        } else {
          Toast.fail(res.message)
        }
      },
      userChange (data) {
        if (data.birthday && data.birthday !== '') {
          this.nianling = this.calculateAge(data.birthday)
        } else {
          this.nianling = ''
        }
        this.xingbie = data.sex
        this.patientId = data.id
        this.selectValue = data
      },
    }
  }
  </script>
  
  
  <style scoped lang="scss">
  .index{
    background: #F6F6F6;
    padding: 10px 15px;
    min-height: 100vh;
    .StandardDescription{
      margin-top:10px;
      .top_nav{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom:10px;
        span {
          display: inline-block;
          width: 5px;
          height: 15px;
          background: #259beb;
          margin-right: 5px;
        }
      }
      .StandardDeatil{
        width:100%;
        padding:15px 10px;
        //   height: 50px;
        background-color: #fff;
        box-sizing: border-box;
      }
    }
    .top_nav{
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom:10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .formBody{
      background-color: #fff;
      padding-bottom:10px;
      .CalculationResultsBox{
        padding:0 8px;
        .CalculationResults{
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          display: flex;
          justify-content: center;
          margin-bottom:10px
        }
        .CalculationDetail{
          font-size: 15px;
          color: #333333;
          // font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: start;
          margin-bottom:10px;
          background-color: #f6f6f6;
          // height: 16px;
          span{
            display: inline-block;
            width: 3px;
            height: 24px;
            background: #fe9712;
            margin-right: 5px;
          }
        }
      }
    }
    .titles{
      display:flex;
      align-items: center;
      justify-content: space-between;
      width:100%;
      height: 50px;
      border-bottom: 1px solid #f0f0f0;
      padding: 0 10px;
      box-sizing: border-box;
      .titlesName{
        font-size:16px;
        i{
          color: red;
        }
      }
      .information{
        font-size:16px;
        margin-right:4px;
        .PleaseSelect{
          color: #b9b9b9;
        }
        .vanCell{
          width:50px;
          padding:0;
          height: 100%;
        }
      }
      .vBotton{
        width:60px
      }
      .unit{
        height: 50px;
        //   line-height: 50px;
        display: flex;
        align-items: center;
        font-size:16px;
        width:20px;
      }
      .vanIcon{
        font-size:13px;
        color:#a8a8a8;
        font-weight: 650;
      }
    }
  }
  ::v-deep .van-cell {
    padding:0px 0px;
  }
  ::v-deep .van-field__control{
    height: 50px;
    font-size: 16px;
  }
  ::v-deep .van-field__error-message {
    position: absolute;
    top: 30px;
    left: 10px;
  }
  .StandardDeatil2{
    width:100%;
    padding: 15px 10px;
    padding-bottom:1px;
    //   height: 50px;
    background-color: #fff;
    box-sizing: border-box;
    .references{
      margin-bottom:15px
    }
  }
  ::v-deep p {
    padding: 0;
    margin: 0;
  }
  .Abutton {
  
  }
  </style>
  